import MobileDetect from 'mobile-detect';

const google_sheets_api_key = 'AIzaSyBNLjVyRu8PfwGsdsbayjax2QPrFFzXtv8'
const mb = new MobileDetect(window.navigator.userAgent);
const MOBILE_YEARS_CACHE_COUNT = Number(process.env.MOBILE_YEARS_CACHE_COUNT) || 3;
const DESKTOP_YEARS_CACHE_COUNT = Number(process.env.DESKTOP_YEARS_CACHE_COUNT) || 10;
export const IS_PHONE = Boolean(mb.phone());
export const YEARS_CACHE_COUNT = IS_PHONE ? MOBILE_YEARS_CACHE_COUNT : DESKTOP_YEARS_CACHE_COUNT;
export const SDN_BASE = process.env.SDN_BASE ?? 'https://468515.selcdn.ru/interactive-reel/';
export const SHEET = `https://sheets.googleapis.com/v4/spreadsheets/1YmyzLRA5fPippNIU__O4zaxfqyt6lcmwSs7FKpdpQsk/values/AIR?alt=json&key=${google_sheets_api_key}`;